import React, { useState } from 'react';

import { Helmet } from 'react-helmet';

import { Box, Button, Container } from '@mui/material';

import PromoAiWorkflowEntry from '~/components/Common/Blocks/PromoAiWorkflowEntry';

import usePromoMeta from '../Promo/hooks/usePromoMeta';

import PromoFormV3 from './PromoFormV3';
import PromoFormV4 from './PromoFormV4';

function PromoContainer() {
  const { promoMeta, promoCodeConditionTypeConfig, isPromoMetaLoading } = usePromoMeta();
  const [showLegacyForm, setShowLegacyForm] = useState(false);
  return (
    <Container>
      <Helmet>
        <title>{showLegacyForm ? 'Legacy Promo Form' : 'Promo Form V4'}</title>
      </Helmet>
      <Box sx={{ mb: 2 }}>
        <PromoAiWorkflowEntry kind="promo" initialAction="create" />
      </Box>
      {showLegacyForm ? (
        <PromoFormV3
          promoCode={null}
          promoMeta={promoMeta}
          isPromoMetaLoading={isPromoMetaLoading}
          promoCodeConditionTypeConfig={promoCodeConditionTypeConfig}
          isDev={false}
        />
      ) : (
        <PromoFormV4 promoCodeId={null} promoCodeName={null} isDev />
      )}
      {!showLegacyForm && (
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="text" onClick={() => setShowLegacyForm(true)}>
            Open legacy promo form
          </Button>
        </Box>
      )}
    </Container>
  );
}

export default PromoContainer;
